import instance from "@/store/actions/instance";
import {
  updateRegisterPOS,
  updateSelectedRegisterPOS,
} from "@/store/actions/pos";
import { Button, Input, InputNumber, message, Table } from "antd";
import React, { useState, useRef, useEffect } from "react";
import { withNamespaces } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
const { Column } = Table;

const EditableContext = React.createContext();

const EditableRow = ({ index, ...props }) => {
  return (
    <EditableContext.Provider>
      <tr {...props} />
    </EditableContext.Provider>
  );
};

const EditableCell = ({
  editable,
  children,
  record,
  handleSave,
  direction,
  initialValue,
  currencyDecimals,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef();
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
  };

  const save = (e) => {
    toggleEdit();
    if (e.target.value && e.target.value !== initialValue)
      handleSave(Number(e.target.value));
  };

  if (editable) {
    children = editing ? (
      <InputNumber
        defaultValue={initialValue}
        ref={inputRef}
        onPressEnter={save}
        onBlur={save}
        style={{ direction: direction }}
        min={0}
      />
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{children}</td>;
};
function PaymentsSummary({
  payments,
  currency,
  t,
  closeModal,
  closingLoading,
  setClosingLoading,
}) {
  const [countedAmount, setCountedAmount] = useState(null);
  const selectedRegister = useSelector((state) => state.pos.selectedRegister);
  const settings = useSelector((state) => state.auth.settings);
  const dispatch = useDispatch();

  const [closingNote, setClosingNote] = useState(null);

  const closeRegister = async () => {
    try {
      setClosingLoading(true);

      const res = await instance.post(`/close_register/`, {
        registerId: selectedRegister.id,
        countedAmount: countedAmount,
        closingNote: closingNote,
      });
      dispatch(updateRegisterPOS(res.data));
      dispatch(updateSelectedRegisterPOS(null));
      closeModal();

      message.success(t("Changed successfully"));
    } catch (err) {
      console.log(err);
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
    setClosingLoading(false);
  };
  const renderColumnDifference = (value, record) => {
    if (record.payment_type !== "cash" || countedAmount == null) return "-";
    return (
      <div>
        {(countedAmount - record.expected).toFixed(settings.currency_decimals)}
      </div>
    );
  };
  return (
    <div>
      <h6>{t("Payments Summary")}</h6>
      <Table
        dataSource={payments}
        size={"small"}
        rowClassName={"text-center editable-row"}
        id={"registerPaymentsSummary"}
        components={{
          body: {
            row: EditableRow,
            cell: EditableCell,
          },
        }}
        pagination={false}
      >
        <Column
          title={t("Payment Type")}
          key="payment_type"
          dataIndex={"payment_type"}
          render={(value) => t(value)}
        />
        <Column
          title={`${t("Received")} (${currency})`}
          key="received"
          dataIndex={"received"}
          render={(value) => value.toFixed(settings.currency_decimals)}
        />
        <Column
          title={`${t("Refunded")} (${currency})`}
          key="refunded"
          dataIndex={"refunded"}
          render={(value) => value.toFixed(settings.currency_decimals)}
        />
        <Column
          title={`${t("Expected")} (${currency})`}
          key="expected"
          dataIndex={"expected"}
          render={(value) => value.toFixed(settings.currency_decimals)}
        />
        <Column
          title={`${t("Counted")} (${currency})`}
          key="counted"
          dataIndex={"counted"}
          render={(value, record) =>
            (record.payment_type === "cash" &&
              (countedAmount !== null
                ? countedAmount.toFixed(settings.currency_decimals)
                : t("Enter Amount"))) ||
            "-"
          }
          onCell={(record, index) => ({
            record,
            editable: record.payment_type == "cash" && true,
            countedAmount: countedAmount,
            currencyDecimals: settings.currency_decimals,
            handleSave: (newAmount) => {
              if (newAmount >= 0 && !Number.isNaN(newAmount)) {
                setCountedAmount(newAmount);
              }
            },
          })}
        />
        <Column
          title={`${t("Difference")} (${currency})`}
          key="difference"
          render={(value, record) => renderColumnDifference(value, record)}
        />
      </Table>
      <div className="d-flex flex-column my-3" style={{ gap: 20 }}>
        <h6>{t("Notes (optional)")}</h6>
        <Input.TextArea
          rows={2}
          onChange={(e) => setClosingNote(e.target.value)}
        />
        <Button
          type="primary"
          disabled={countedAmount === null}
          loading={closingLoading}
          onClick={closeRegister}
        >
          {t("Close Register")}
        </Button>
      </div>
    </div>
  );
}

export default withNamespaces()(PaymentsSummary);
